import { observable } from 'mobx'
import moment from 'moment';

class Turnus {
    @observable public id: number;
    @observable public idKlient: number;
    @observable public idObjednavka: number;
    @observable public od: Date;
    @observable public do: Date;
    @observable public program: number;
    @observable public rozsah: string[];

    public clone(): Turnus {
        const newDen: Turnus = new Turnus();
        newDen.loadFromEntity(this);
        return newDen;
    }

    public loadFromJSON(json: any): Turnus {
        this.id = json.id;
        this.idKlient = json.id_klient;
        this.idObjednavka = json.id_objednavka;
        this.od = moment(json.od).toDate();
        this.do = moment(json.do).toDate();
        this.program = json.program;
        this.rozsah = json.rozsah;
        return this;
    }

    public loadFromEntity(ent: Turnus): Turnus {
        this.id = ent.id;
        this.idKlient = ent.idKlient;
        this.idObjednavka = ent.idObjednavka;
        this.od = ent.od;
        this.do = ent.do;
        this.program = ent.program;
        this.rozsah = ent.rozsah;
        return this;
    }

    // Business logic

    public getLength(): number {
        const one = moment(this.od);
        const two = moment(this.do);

        const diffWeeks = moment.duration(two.diff(one)).asWeeks();
        return Math.floor(diffWeeks) + 1;
    }

    // 0 - not started, -1 ended, X - week number (1,2,3...)
    public getProgress(): number {
        if(moment().isBefore(this.od)) {
            return 0;
        }
        if(moment().isAfter(this.do)) {
            return -1;
        }
        const odWeek: number = moment(this.od).week();
        const nowWeek: number = moment().week();
        return (nowWeek - odWeek) + 1;
    }
}

export default Turnus;


// WEBPACK FOOTER //
// ./src/models/Turnus.tsx